import { Hub } from '../hub/hub';
import { SocialNetWorkThread } from '../social-network-thread';

export class Video extends SocialNetWorkThread {
  public hub: Hub;
}
